import { container, singleton } from 'tsyringe';
import { PipesUsageViewModel } from '../models/pipes-usage-view-model';
import { UsageCostModel } from '../models/usage-cost-model';
import { AuthService } from './auth.service';
import { BaseApi } from './base.api';
import { PipeUsageViewModel } from '../models/pipe-usage-view-model';
import { OrganizationUsageModel } from "../models/organization-usage-model";
import { AdminChartDataRequest, AdminChartDataResponse, AdminOrgTableRequest, AdminOrgTableResponse } from '../models/admin-usage.model';
import { NetworkResult } from 'se-shared/utils/result';


@singleton()
export class UsageApi extends BaseApi {
    private _authService: AuthService;
    constructor() {
        super();
        this._authService = container.resolve(AuthService);
    }
    async connectAsync(id: number) {
        return this.postObjectAsync(`/api/server/${id}/connect`, undefined, this._authService.token);
    }
    async getAllUsageAsync(pageIndex = 1, recordsPerPage = 100, pipeUsageName: string = '', sortOrder: number = -1) {
        return this.getObjectAsync<PipesUsageViewModel>(`/api/usage/pipeUsage?pageIndex=${pageIndex}&recordsPerPage=${recordsPerPage}&pipeUsageName=${pipeUsageName}&sortOrder=${sortOrder}`, this._authService.token);
    }

    async getServersUsageAsync(timeUnit: string, startDate, endDate) {
        return this.getObjectAsync(`/api/usage/serverUsage?timeUnit=${timeUnit}&startDate=${startDate}&endDate=${endDate}`, this._authService.token);
    }

    async getOrgRunsDataUsageAsync(orgId: number, timeUnit: string, startDate, endDate) {
        return this.getObjectAsync<UsageCostModel>(`/api/usage/runs-data/org/${orgId}/${timeUnit}?startDate=${startDate}&endDate=${endDate}`, this._authService.token);
    }

    async getOrgPipesUsageAsync(usageRequest: any) {
        return this.postObjectReturnObjectAsync<PipesUsageViewModel>(`/api/usage/pipes-usage/org?source=controlcenter`, usageRequest, this._authService.token);
    }
    async getOrgPipeUsageAsync(usageRequest: any) {
        return this.postObjectReturnObjectAsync<PipesUsageViewModel>(`/api/usage/pipe-runs?source=controlcenter`, usageRequest, this._authService.token);
    }
    async getOrgPipeRunsUsageAsync(pipeId: number, timeUnit: string, startDate, endDate) {
        return this.getObjectAsync<UsageCostModel>(`/api/usage/pipe-usage/${pipeId}/${timeUnit}?startDate=${startDate}&endDate=${endDate}`, this._authService.token);
    }

    async getRunUsageTypesAsync(runId: number) {
        return this.getObjectAsync<PipesUsageViewModel>(`/api/usage/run/${runId}/usage-types`, this._authService.token);
    }

    async getAllOrgsRunsDataUsageAsync(timeUnit: string, startDate, endDate, hideAdminOrgs: boolean = true) {
        return this.getObjectAsync<OrganizationUsageModel>(`/api/usage/runs-data/all-orgs/${timeUnit}?startDate=${startDate}&endDate=${endDate}&hideAdminOrgs=${hideAdminOrgs}`, this._authService.token);
    }

    async getAdminOrgUsageTableAsync(request: AdminOrgTableRequest): Promise<NetworkResult<AdminOrgTableResponse>> {
        return this.postObjectReturnObjectAsync<AdminOrgTableResponse>('/api/usage/admin/org-usage-table', request, this._authService.token);
    }

    async getAdminUsageChartDataAsync(timeUnit: string, startDate: string, endDate: string, filterOutAdminOrgs: boolean = true): Promise<NetworkResult<AdminChartDataResponse>> {
        return this.getObjectAsync<AdminChartDataResponse>(`/api/usage/admin/usage-chart-data/${timeUnit}?startDate=${startDate}&endDate=${endDate}&filterOutAdminOrgs=${filterOutAdminOrgs}`, this._authService.token);
    }

    async getBillingCostsAsync() {
        return this.getObjectAsync(`/api/usage/billing-costs`, this._authService.token);
    }

    async updateBillingCostsAsync(billingCosts: any[]) {
        return this.putObjectAsync(`/api/usage/billing-costs`, billingCosts, this._authService.token);
    }
}